import React, { Component } from 'react';
import { connect } from "react-redux";
import { Row, Grid, Button } from 'react-bootstrap';
import { setLoader, setTab } from "../../redux/actionCreators";
import './documentReview.css';
import ProcessResumeInfo from './ProcessResumeInfo';
import PdfViewer from './PdfViewer';
import FooterContainer from '../../components/footer/FooterContainer';
import MainButton from '../../components/buttons/main_button/MainButton';

const PROCESS_TAB = 0;
const REVIEW_TAB = 1;

const HEADER_NAV_TABS = {
    PROCESS : PROCESS_TAB,
    REVIEW: REVIEW_TAB,
}

const DOCUMENT_RESUME_INFO = 0;
const DOCUMENT_REVIEW = 1;

const SUB_COMPONENTS = {
    RESUME_INFO : DOCUMENT_RESUME_INFO,
    VIEW_DOCUMENT: DOCUMENT_REVIEW,
};

class PDFViewer extends Component {
    constructor(props) {
        super(props);
        this.state = {
            selectedComponent : HEADER_NAV_TABS.PROCESS
        }
    }

    componentDidMount() {
        this.props.setLoader(false);
    }

    selectComponent = (value) => {
        this.setState({ selectedComponent: value });
    }

    goBackToSignProcessTab = () => { this.props.setTab(HEADER_NAV_TABS.REVIEW); this.selectComponent(SUB_COMPONENTS.RESUME_INFO)};

    render() {
        return (
            <div className={'pdf-viewer'}>
                <Grid>
                    { this.props.processResumeComponent && this.state.selectedComponent === HEADER_NAV_TABS.PROCESS ?
                    <Row>
                        <ProcessResumeInfo viewDocumentButton={this.props.viewDocumentButton}
                                        selectComponent={this.selectComponent}
                                        backButton={this.props.backButton}/>
                    </Row>
                    : <React.Fragment/>
                    }
                    { this.props.pdfViewerComponent || this.state.selectedComponent === HEADER_NAV_TABS.REVIEW?
                    <Row>
                    <PdfViewer clauseAndNextButton={this.props.clauseAndNextButton}
                                downloadDocument={this.props.downloadDocument}
                                nextStep={this.props.nextStep}
                                buttonText={this.props.buttonText}
                                activeTab={this.state.selectedComponent}
                    />
                    </Row>
                    : <React.Fragment/>
                    }

                </Grid>
                { this.props.backButton && SUB_COMPONENTS.VIEW_DOCUMENT === this.state.selectedComponent &&
                   <FooterContainer>
                        <MainButton
                            onClick={this.goBackToSignProcessTab}
                            text={'Volver'}
                        />
                   </FooterContainer>
                }
            </div>
        );
    }
}


const mapStateToProps = state => {
    return {
        loader: state.loader,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        setLoader(loader) {
            dispatch(setLoader(loader));
        },
        setTab(tab) {
            dispatch(setTab(tab));
        }
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(PDFViewer);